export default __webpack_public_path__ + "static/media/foodhub-nrw.61342256.png";